import { ReactNode, useRef, useEffect } from 'react';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { Box, Typography, useTheme } from '@mui/material';

interface FormulaFieldContainerProps {
  children: ReactNode;
  label: string;
  onClose: () => void;
}

const FormulaFieldContainer = ({
  children,
  label,
  onClose,
}: FormulaFieldContainerProps) => {
  const theme = useTheme();
  const ref = useRef<HTMLElement>();

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }, [ref]);

  return (
    <Box
      ref={ref}
      display="flex"
      flexDirection="column"
      padding={theme.spacing(2)}
      gap={theme.spacing(2)}
      borderRadius={theme.spacing(1)}
      sx={{
        backgroundColor: theme.palette.grey[800],
      }}
    >
      <Box display="flex">
        <Typography flexGrow={1} fontWeight={500}>
          {label}
        </Typography>
        <DeleteIcon
          sx={{
            color: theme.palette.grey[400],
            width: theme.spacing(2),
            '&:hover': {
              color: theme.palette.grey[50],
            },
          }}
          cursor="pointer"
          onClick={onClose}
        />
      </Box>
      <Box>{children}</Box>
    </Box>
  );
};

export default FormulaFieldContainer;
